import { MatPaginatorIntl } from '@angular/material/paginator';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';


// eslint-disable-next-line @typescript-eslint/naming-convention,prefer-arrow/prefer-arrow-functions
export function CustomPaginator(translate: TranslateService) {
  const customPaginatorIntl = new MatPaginatorIntl();
  customPaginatorIntl.itemsPerPageLabel = translate.instant(
    marker('global.labels.paginator.itemsPerPageLabel'),
  );
  customPaginatorIntl.nextPageLabel = '';
  customPaginatorIntl.previousPageLabel = '';
  return customPaginatorIntl;
}

export const paginatorDeps = {
  provide: MatPaginatorIntl,
  useFactory: CustomPaginator,
  deps: [TranslateService],
};
